import api from '@/lib/api';
import type { UserChatbotResponse } from '@/features/auth/types';

type ApiResponse<T> = {
  success: boolean;
  data?: T;
  message?: string;
  error?: string;
};

export const userChatbotsApi = {
  async listMine(): Promise<UserChatbotResponse[]> {
    const response = await api.get<ApiResponse<UserChatbotResponse[]>>('/platform/auth/chatbots');
    if (!response.data.success) {
      throw new Error(
        response.data.error || response.data.message || 'No se pudieron cargar tus chatbots'
      );
    }
    return response.data.data || [];
  },
};
